

    import Vue from 'vue';
    import Component from "vue-class-component";
    import {
AvailableActions,
        EducationalQualificationRecordDetailsModel,
        factory,
        QualificationRecordDetailsModel,
        QualificationRecordResultModel,
        QualificationRecordsClient, RemoveQualificationRecordResultModel, ResultError, SeafarersClient, TrainingQualificationRecordDetailsModel, UpdateQualificationResultModel,
    } from "@/api-client";
    import EducationalQualificationRecordDetails from "./EducationalQualificationRecordDetails.vue";
    import TrainingQualificationRecordDetails from "./TrainingQualificationRecordDetails.vue";
    import {Prop} from "vue-property-decorator";
    import {BModal, BTable, BvTableFieldArray} from "bootstrap-vue";
    import QualificationResultAddModal from "../components/QualificationResultAddModal.vue";
    import QualificationResultEditModal from "../components/QualificationResultEditModal.vue";
    import SectionDocumentMetaData from "@/features/shared/components/sections/SectionDocumentMetaData.vue";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import SetQualificationResultAsPassedModal
        from "@/features/documents/qualifications/records/components/SetQualificationResultAsPassedModal.vue";
    import SetQualificationResultAsFailedModal
        from "@/features/documents/qualifications/records/components/SetQualificationResultAsFailedModal.vue";
    import {RecordDetailsProps} from "@/features/documents/qualifications/records/views/RecordDetailsProps";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
    import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import {NavigationGuardNext} from "vue-router/types/router";
    import ConfirmModal from "@/features/shared/components/ConfirmModal.vue";
    import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";
    import ButtonWithConfirmAndComment from "@/features/shared/components/ButtonWithConfirmAndComment.vue";
import toasts from '@/components/Toasts';

    interface Props {
        props: RecordDetailsProps;
        id:string
        canViewInactiveSeafarers: boolean;
        actions: AvailableActions;
    }

    @Component({
        components: {
            QualificationResultAddModal,
            QualificationResultEditModal,
            SectionDocumentMetaData,
            SectionPageHeading,
            EducationalQualificationRecordDetails,
            TrainingQualificationRecordDetails,
            SetQualificationResultAsPassedModal,
            SetQualificationResultAsFailedModal,
            TableEmptySlot,
            HeadingGroup,
            ConfirmModal,
            ButtonWithConfirm,
            ButtonWithConfirmAndComment
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<QualificationRecordDetails>) {
            const metaProps = to.meta!.props as Props;
            metaProps.id = to.params.id;
            Promise.all([
                new SeafarersClient().availableSearchActions(),
                new QualificationRecordsClient().availableRecordActions(to.params.id)
            ]).then(values => {
                metaProps.canViewInactiveSeafarers = values[0].canViewInactiveSeafarers;
                metaProps.actions = values[1];
                next();
            }).catch(e => next(e))
        }
    })
    export default class QualificationRecordDetails extends Vue implements Props {
        @Prop({required: true})
        props!: RecordDetailsProps;
        @Prop({required: true})
        id!:string;
        @Prop({default: false})
        canViewInactiveSeafarers!:boolean;
        @Prop({default:false})
        actions!: AvailableActions;

        dataLoaded = false;

        details: QualificationRecordDetailsModel = factory.create(this.props.detailsType);
        errors: ResultError = factory.create(ResultError);

        $refs!: {
            submitModal: BModal;
            table: BTable;
            confirmParticipantRemoval: ConfirmModal

        };

        async created() {
            await this.refresh();
            this.dataLoaded = true;
        }

        async refresh(){
            this.details = await this.props.getDetails(this.id);
        }

        async removeResult(result: QualificationRecordResultModel, comment: string) {
            const index = this.details.qualificationResults.indexOf(result);
            this.details.qualificationResults.splice(index, 1);

            if (this.isSubmitted) {
                await this.removeQualificationResultAfterSubmitting(result, comment);
            } else {
                await this.updateQualificationResultsBeforeSubmitting();
            }
        }

        get componentTypeName() {
            return this.details instanceof TrainingQualificationRecordDetailsModel ? "TrainingQualificationRecordDetails"
                : this.details instanceof EducationalQualificationRecordDetailsModel ? "EducationalQualificationRecordDetails"
                    : "Unknown";
        }

        async addResult(result: QualificationRecordResultModel) {
            const existingResult = this.details.qualificationResults.filter(r => r.seafarer!.id === result.seafarer!.id)[0];
            if (existingResult) {
                this.$set(this.details.qualificationResults, this.details.qualificationResults.indexOf(existingResult), result);
            } else {
                this.details.qualificationResults.push(result);
            }

            if (this.isSubmitted) {
                await this.addQualificationResultAfterSubmitting(result);
            }
            else {
                await this.updateQualificationResultsBeforeSubmitting();
            }
        }

        async removeQualificationResultAfterSubmitting(result: QualificationRecordResultModel, comment: string) {
            const removeModel = factory.create(this.props.removeResultType);
            removeModel.recordId = this.details.id!;
            removeModel.seafarerId = result.seafarer!.id;
            removeModel.comment = comment;
            new QualificationRecordsClient().removeQualificationResult(removeModel)
                .then(async () => await this.refresh()).catch(error => {
                    this.refresh();
                    if(error instanceof ResultError){
                        const resultError = error as ResultError;
                        resultError.messagesFlattened.forEach( m => {
                            toasts.failure(m);
                        });
                    }
                    else{
                        throw error;
                    }

                });
        }

        async addQualificationResultAfterSubmitting(result: QualificationRecordResultModel) {
            const addModel = factory.create(this.props.addResultType);
            addModel.recordId = this.details.id!;
            addModel.qualificationResult = new UpdateQualificationResultModel();
            addModel.qualificationResult.seafarerId = result.seafarer!.id;
            addModel.qualificationResult.certificateNumber = result.certificateNumber;
            addModel.qualificationResult.passed = result.passed;
            //for validation purposes
            addModel.qualificationResult.recordId = this.details.id!;
            addModel.qualificationResult.comment = result.comment;

            addModel.comment = result.comment;
            await new QualificationRecordsClient().addQualificationResult(addModel)
                .then(async () => await this.refresh())
                .catch(()=>toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove));
        }

        async updateQualificationResultsBeforeSubmitting() {
            const updateModel = factory.create(this.props.updateResultsType);
            updateModel.recordId = this.details.id!;
            updateModel.qualificationResults = this.details.qualificationResults.map(r => {
                const result = new UpdateQualificationResultModel();
                result.recordId = this.details.id!;
                result.seafarerId = r.seafarer!.id;
                result.certificateNumber = r.certificateNumber;
                result.passed = r.passed;
                result.comment = r.comment;
                return result;
            });
            await new QualificationRecordsClient().updateQualificationResults(updateModel)
                .then(async () => await this.refresh())
                .catch(()=>toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove));
        }

        async submit() {
            this.errors = factory.create(ResultError);
            const submitRequest = factory.create(this.props.submitType);
            submitRequest.recordId = this.details.id!;
            submitRequest.version = this.details.version;
            await new QualificationRecordsClient().submit(submitRequest).then(
                success => this.details.submittedOn = success.submittedOn,
                error => this.setValidationErrors(error, null, "errors"));

            this.$refs.submitModal.hide();
        }

        get isSubmitted(): boolean {
            return !!this.details.submittedOn;
        }

        async deleteQualificationRecord() {
            await new QualificationRecordsClient()
                .deleteRecord(this.id)
                .then(async () => {
                    toasts.success(this.$ls.Documents_Toast_Success_DocumentDeletion);
                });

            this.$router.push({name: "qualification-records", params: {}});
        }

        navigateToEdit() {
            this.$router.push({name: this.props.editRouteName, params: {id: this.details.id ?? ""}});
        }

        fields:BvTableFieldArray = [
            {
                key: 'rangeNumber',
                label: this.$ls.Documents_Qualifications_Records_Table_Label_Number,
                sortable: false,
                thClass: "w-8"
            },
            {
                key: 'name',
                label: this.$ls.Documents_Qualifications_Records_Table_Label_Seafarer,
                sortable: true,
                formatter: (value: any, key: any, item: QualificationRecordResultModel) => {
                    return `${item.seafarer?.firstName} ${item.seafarer?.lastName}`
                },
                sortByFormatted: true,
                filterByFormatted: true,
                thClass: "w-20"
            },
            {
                key: 'seafarer.personalCode',
                label: this.$ls.Documents_Qualifications_Records_Table_Label_PersonalCode,
                sortable: false,
                thClass: "w-10"
            }
            ,
            {
                key: 'certificateNumber',
                label: this.$ls.Documents_Qualifications_Records_Table_Label_CertificateNumber,
                sortable: true,
                thClass: 'w-15'
            },
            {
                key: 'passed',
                label: this.$ls.Documents_Qualifications_Records_Table_Label_Passed,
                sortable: true,
                formatter: (value: boolean) => translateTrueFalse(value),
                thClass: 'w-10'
            },
             {
                key: 'resultHasChanged',
                label: this.$ls.Documents_Qualifications_Records_Table_Label_HasResultChanged,
                sortable: false,
            },
            {
                key: 'buttons',
                label: '',
                sortable: false,
                thClass: 'w-25',
                tdClass: 'table-actions'
            }
        ];
    }
